import dynamic from 'next/dynamic';
const HeroPrimary = dynamic(() => import('./HeroPrimary'));
export default HeroPrimary;
